export const educationConfig = [
  {
    org: "Delhi Technological University",
    session: "2018 — 2022",
    course: "Bachelor of Technology in Electronics and Communication Engineering",
  },
  {
    org: "Chhotu Ram Rural Institute of Technology",
    session: "2014 — 2017",
    course: "Diploma in Electronic Engineering",
  },
  {
    org: "Government Sarvodaya Bal Vidyalaya A-block, Vikas puri",
    session: "2013 — 2014",
    course: "Secondary School Certificate (Class 10th)",
  },
];

export const experienceConfig = [
  {
    designation: "Frontend Engineer",
    tenure: "Oct, 2022 — Present",
    // name: "Impressico Business Solutions",
  },
];

export const skillsConfig = [
  {
    name: "HTML/CSS",
    level: "80",
  },
  {
    name: "React.js",
    level: "70",
  },
  {
    name: "Coding Languages (Java, JavaScript)",
    level: "80",
  },
  {
    name: "Development",
    level: "60",
  },
];
